import BreadcrumbList from '@root/modules/Sellers/Stock/components/Breadcrumb';
import forwarderService from '../service';

import { Button, Col, Form, Input, Row, message } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import { useEffect, useState } from 'react';

const MyPage = () => {
  const [form] = Form.useForm();
  const [myInfo, setMyInfo] = useState([]);
  useEffect(() => {
    const fetchMyInfo = async () => {
      const res = await forwarderService.getMyInfo();
      setMyInfo(res);
    };
    fetchMyInfo();
  }, []);
  useEffect(() => {
    form.setFieldsValue({
      ...myInfo
    });
  }, [myInfo]);

  const editMyInfo = async () => {
    if (
      form.getFieldValue('password') !== form.getFieldValue('passwordConfirm')
    ) {
      message.error('비밀번호가 일치하지 않습니다.');
      return;
    }
    const res = await forwarderService.updateMyInfo(form.getFieldsValue());
    alert('수정되었습니다.');
    console.log(res);
  };
  return (
    <div>
      <BreadcrumbList listBreadcrumb={[{ tittle: 'My Account', url: '' }]} />
      <div className="busk-container">
        <div
          style={{
            padding: '1rem',
            backgroundColor: 'white'
          }}
          id="busk-DetailForm"
        >
          <Form
            name="basic"
            className="forwarding-form"
            layout="vertical"
            // onFinish={onFinish}
            // onFinishFailed={onFinishFailed}
            form={form}
          >
            <Row gutter={24}>
              {/* Left Form */}
              <Col flex={'1'}>
                <Row>
                  <Form.Item label="Forwarding Company Name" name="name">
                    <Input />
                  </Form.Item>
                </Row>
                <Row>
                  <Form.Item label="Company Administration Name" name="manager">
                    <Input />
                  </Form.Item>
                </Row>
                <Row>
                  <Form.Item label="ID (Email)" name="email">
                    <Input className="input-style" readOnly />
                  </Form.Item>
                </Row>
                <Row>
                  <Form.Item label="password" name="password">
                    <Input />
                  </Form.Item>
                </Row>
                <Row>
                  <Form.Item label="passwordConfirm" name="passwordConfirm">
                    <Input />
                  </Form.Item>
                </Row>
                <Row>
                  <Form.Item label="Country Name" name="country">
                    <Input />
                  </Form.Item>
                </Row>
                <Row>
                  <Form.Item label="Communication Language" name="locale">
                    <Input />
                  </Form.Item>
                </Row>
                <Row>
                  <Form.Item label="Main Task" name="description">
                    <TextArea rows={5} style={{ borderRadius: 8 }} />
                  </Form.Item>
                </Row>
              </Col>
            </Row>
          </Form>
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button className="btn-style" type="primary" onClick={editMyInfo}>
              Request for modification
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyPage;
